import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";

const AA_CATEGORY = {
  ALA: "Non-polar", CYS: "Non-polar", GLY: "Non-polar", ILE: "Non-polar",
  LEU: "Non-polar", MET: "Non-polar", PHE: "Non-polar", PRO: "Non-polar",
  TRP: "Non-polar", VAL: "Non-polar",
  ASN: "Polar", GLN: "Polar", SER: "Polar", THR: "Polar", TYR: "Polar",
  ARG: "Positive", HIS: "Positive", LYS: "Positive",
  ASP: "Negative", GLU: "Negative",
};

const CATEGORY_COLORS = {
  "Non-polar": "#f4d03f", // yellow
  "Polar":     "#5dade2", // blue
  "Positive":  "#58d68d", // green
  "Negative":  "#bb8fce", // purple
};

// Display order on the X axis
const CATEGORY_ORDER = ["Non-polar", "Polar", "Positive", "Negative"];

const AADistanceBoxplot = ({ contactData }) => {
  const [plotData, setPlotData] = useState([]);
  const [layout, setLayout] = useState({});

  useEffect(() => {

    if (!Array.isArray(contactData) || contactData.length === 0) {
      setPlotData([]);
      return;
    }

    // Bucket distances by category. Each contact contributes the same distance
    // value to BOTH residues' categories (e.g. a LEU–ASP contact at 5.2 Å adds
    // 5.2 Å to both Hydrophobic and Acidic buckets).
    const buckets = {};
    CATEGORY_ORDER.forEach((c) => { buckets[c] = []; });

    contactData.forEach(({ details, distance }) => {
      const d = parseFloat(distance);
      if (!details || isNaN(d)) return;

      const parts = details.split('|');
      for (let i = 0; i < parts.length; i++) {
        const tokens = parts[i].trim().split('/');
        if (tokens.length >= 4) {
          const aa = tokens[3].trim().toUpperCase();
          const cat = AA_CATEGORY[aa];
          if (cat) buckets[cat].push(d);
        }
      }
    });

    // One trace per category — keeps the legend interactive and color-consistent
    const traces = CATEGORY_ORDER
      .filter((cat) => buckets[cat].length > 0)
      .map((cat) => ({
        y: buckets[cat],
        name: cat,
        type: "box",
        boxpoints: "outliers",
        marker: { color: CATEGORY_COLORS[cat] },
        line:   { color: CATEGORY_COLORS[cat] },
        fillcolor: CATEGORY_COLORS[cat] + "33", // ~20% opacity
        hovertemplate: `${cat}<br>Distance: %{y:.2f} Å<extra></extra>`,
      }));

    setPlotData(traces);

    setLayout({
      autosize: true,
       font: { size: 9 },
      title: {
        text: "Contact Distance by Amino Acid Category",
      },
      xaxis: {
        type: "category",
        title: { text: "Amino acid category" },
      },
      yaxis: {
        title: { text: "Distance (Å)" },
        zeroline: false,
      },
      showlegend: true,
      legend: {
        title: { text: "Category" },
        orientation: "v",
        x: 1.02,
        y: 1,
      },
      margin: { t: 50, b: 80, l: 60, r: 80 },
    });
  }, [contactData]);

  return (
    <div className="aspect-square card">
      <Plot
        data={plotData}
        layout={layout}
        useResizeHandler
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default AADistanceBoxplot;
